import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import BounceSpinner from './spinner/bounce';

function ProcessingButton({
                              title,
                              isButton = true
                          }) {
    return (
        <a className={classNames('spinner', {btn: isButton})}>
            {title}

            <BounceSpinner/>
        </a>
    );
}

ProcessingButton.propTypes = {
    title: PropTypes.string.isRequired,
    isButton: PropTypes.bool,
};

export default React.memo(ProcessingButton);
